import React from "react";
import clsx from "clsx";

interface RatingProps {
  color?: "primary" | "secondary" | "default";
  value: number;
  total: number;
}

const Rating = (props: RatingProps) => {
  const { color = "default", value, total } = props;
  return (
    <div className="grid grid-rows-1 gap-2">
      {new Array(total).fill(0).map((_, i) => (
        <div
          key={i}
          className={clsx('-skew-x-[7.125deg] row-start-1 h-4 border-1 border-solid border-current',{
            'text-primary': color === 'primary',
            'text-secondary': color === 'secondary',
            'text-foreground': color === 'default',
            'bg-current': i < value,
          })}
        />
      ))}
    </div>
  );
};

export default Rating;
